<script setup lang="ts">
import { Participant } from '@collector/sportsapi-client-legacy'

import MainResult from './MainResult.vue'
import OverResult from './OverResult.vue'

defineProps<{
  participant: Participant
}>()
</script>

<template>
  <MainResult
    :class="$attrs.class"
    :participant
  />
  <OverResult
    :class="$attrs.class"
    :participant
  />
</template>
